module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column",
    class: ("column_" + _vm.size + " align_" + _vm.align + (_vm.mobile ? '' : ' mobile_hidden'))
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd6522a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/columns/Column.vue
// module id = 144
// module chunks = 0